import { render } from "./Consignment.vue?vue&type=template&id=7b4a692a&scoped=true"
import script from "./Consignment.vue?vue&type=script&lang=js"
export * from "./Consignment.vue?vue&type=script&lang=js"

import "./Consignment.vue?vue&type=style&index=0&id=7b4a692a&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4a692a"]])

export default __exports__